// 活动页面
const Activity = r => require.ensure([], () => r(require('./')), 'Activity')
const Template = r => require.ensure([], () => r(require('./template_1/')), 'Template')

export default {
  path: '/activity/',
  component: Activity,
  children: [{
    path: 'template/:templateId',
    meta: { title: '活动详情' },
    component: Template
  }]
}


// WEBPACK FOOTER //
// ./src/views/activity/router.js